import React from 'react';
import { Controller } from 'react-hook-form';
import YesNoQuestion, {
    YesNoState,
} from '@alfa-retail-react/components/yes-no-question';
import { observer } from 'mobx-react';
import { useFormContext } from '@alfa-retail-react/components/form-hook';

import { EmploymentPageStore } from 'app/logic/pages/employment/EmploymentPageStore';
import { Section } from 'app/component/Section';
import { EmploymentFormValues } from 'app/logic/pages/employment/EmploymentPage';
import { AddressForm } from 'app/logic/address/AddressForm';
import { ValidationRules } from 'app/form/ValidationRules';

export interface DeliveryAddressFormSectionProps {
    pageStore: EmploymentPageStore;
}

export const DeliveryAddressFormSection = observer(
    ({ pageStore }: DeliveryAddressFormSectionProps) => {
        const { formStore } = pageStore;
        const { control, handleMultipleErrors } =
            useFormContext<EmploymentFormValues>();

        return (
            <Section
                className={'deliveryAddressFormSection'}
                content={
                    <>
                        <Controller<EmploymentFormValues>
                            defaultValue={formStore.sameAddress}
                            control={control}
                            name={'sameAddress'}
                            rules={{ required: ValidationRules.required() }}
                            render={({ field, fieldState }) => {
                                return (
                                    <YesNoQuestion
                                        className={'deliveryAddressQuestion'}
                                        radioListClassName={
                                            'deliveryAddressOptions'
                                        }
                                        question={
                                            'Адрес доставки совпадает с адресом проживания?'
                                        }
                                        error={handleMultipleErrors(
                                            fieldState.error,
                                        )}
                                        value={formStore.sameAddress}
                                        fields={[
                                            {
                                                key: YesNoState.YES,
                                                title: 'Да',
                                            },
                                            {
                                                key: YesNoState.NO,
                                                title: 'Нет',
                                            },
                                        ]}
                                        onChange={(event, payload) => {
                                            field.onChange(payload);
                                            formStore.setSameAddress(payload);
                                        }}
                                    />
                                );
                            }}
                        />

                        {formStore.sameAddress === YesNoState.NO && (
                            <>
                                <h3 className={'deliveryAddressTitle'}>
                                    Адрес доставки карты
                                </h3>
                                <AddressForm<EmploymentFormValues, unknown>
                                    prefix={'deliveryAddress'}
                                    formStore={
                                        formStore.deliveryAddressFormStore
                                    }
                                />
                            </>
                        )}
                    </>
                }
            />
        );
    },
);
